const PROPERTY_TYPE_TO_ABBR = {
  'Single Family Detached': 'SFD',
  Townhouse: 'TH',
  Condominium: 'CND',
  'Manufactured/Mobile Home': 'MFH',
  'Income Generating Property': 'INC',
  Multifamily: 'INC'
};

export const propertyTypeToAbbr = (propType) => PROPERTY_TYPE_TO_ABBR[propType];
